<!-- Dialog title and close button -->
<div class="bottom-shadow dialog-title-padding">
    <div class="page-title">
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
            <mat-icon mat-dialog-close class="cursor">keyboard_backspace</mat-icon>
            <h3 class="lato-regular">Edit Profile</h3>
        </div>
        <div>
            <mat-icon mat-dialog-close class="cursor">close</mat-icon>
        </div>
    </div>
</div>




<!-- Middle section of the dialog -->
<div class="middle-sec dialog-middle">
    <div class="height">

        <form [formGroup]="form">
            <div class="root">
                <div fxlayout="row">
                    <div fxFlex="100">
                        <div class="err">
                            *Required Fields
                        </div>
                    </div>
                </div>
                <div fxlayout="row" fxLayoutGap="10px">
                    <div fxFlex="33">
                        <!-- Title -->
                        <mat-form-field appearance="outline" class="form-field" #titleInput
                            (mouseenter)="errorMessage1.style.display = (form.get('title')?.invalid && form.get('title')?.touched) ? 'block' : 'none'"
                            (mouseleave)="errorMessage1.style.display = 'none'">
                            <mat-label>Title</mat-label>
                            <mat-select formControlName="title" required>
                                <mat-option *ngFor="let title of titles" [value]="title">{{ title}}</mat-option>
                            </mat-select>
                            <span matSuffix *ngIf="form.get('title')?.invalid && form.get('title')?.touched">
                                <mat-icon class="alert">priority_high</mat-icon>
                            </span>
                            <div class="custom-message" #errorMessage1
                                [style.display]="(form.get('title')?.invalid && form.get('title')?.touched) ? 'block' : 'none'">
                                Field is required
                            </div>
                        </mat-form-field>
                        <!-- Middle Name -->
                        <mat-form-field appearance="outline" style="width: 180px;" #middleNameInput
                            (mouseenter)="errorMessage2.style.display = (form.get('middleName')?.invalid && form.get('middleName')?.touched) ? 'block' : 'none'"
                            (mouseleave)="errorMessage2.style.display = 'none'">
                            <mat-label>Middle Name</mat-label>
                            <input matInput formControlName="middleName" required>
                            <span matSuffix *ngIf="form.get('middleName')?.invalid && form.get('middleName')?.touched">
                                <mat-icon class="alert">priority_high</mat-icon>
                            </span>
                            <div class="custom-message" #errorMessage2
                                [style.display]="(form.get('middleName')?.invalid && form.get('middleName')?.touched) ? 'block' : 'none'">
                                Field is required
                            </div>
                        </mat-form-field>
                    </div>
                    <div fxFlex="33">
                        <!-- Firstname -->
                        <mat-form-field appearance="outline" style="width: 180px;" #firstNameInput
                            (mouseenter)="errorMessage3.style.display = (form.get('firstName')?.invalid && form.get('firstName')?.touched) ? 'block' : 'none'"
                            (mouseleave)="errorMessage3.style.display = 'none'">
                            <mat-label>First Name</mat-label>
                            <input matInput formControlName="firstName" required>
                            <span matSuffix *ngIf="form.get('firstName')?.invalid && form.get('firstName')?.touched">
                                <mat-icon class="alert">priority_high</mat-icon>
                            </span>
                            <div class="custom-message" #errorMessage3
                                [style.display]="(form.get('firstName')?.invalid && form.get('firstName')?.touched) ? 'block' : 'none'">
                                Field is required
                            </div>
                        </mat-form-field>
                        <!-- Last Name -->
                        <mat-form-field appearance="outline" style="width: 180px;" #lastNameInput
                            (mouseenter)="errorMessage4.style.display = (form.get('lastName')?.invalid && form.get('lastName')?.touched) ? 'block' : 'none'"
                            (mouseleave)="errorMessage4.style.display = 'none'">
                            <mat-label>Last Name</mat-label>
                            <input matInput formControlName="lastName" required>
                            <span matSuffix *ngIf="form.get('lastName')?.invalid && form.get('lastName')?.touched">
                                <mat-icon class="alert">priority_high</mat-icon>
                            </span>
                            <div class="custom-message" #errorMessage4
                                [style.display]="(form.get('lastName')?.invalid && form.get('lastName')?.touched) ? 'block' : 'none'">
                                Field is required
                            </div>
                        </mat-form-field>
                    </div>
                    <div fxFlex="33" class="align">
                        <!-- Image Select -->
                        <input type="file" #fileInput style="display: none" (change)="onFileSelected($event)"
                            name="file" formControlName="profileImage" accept="image/*"/>

                        <img *ngIf="!form.get('profileImage')?.value" src="../../../../../assets/images/gallery.png"
                            class="round-img" (click)="fileInput.click()" />

                        <!-- Image preview -->
                        <img *ngIf="form.get('profileImage')?.value" [src]="form.get('profileImage')?.value"
                            class="uploaded-img" alt="Uploaded Image Preview" (click)="clearImage()" />
                        <div class="round-icon" (click)="fileInput.click()"><i class="fa fa-plus"
                                aria-hidden="true"></i>
                        </div>
                    </div>
                </div>
                <!-- DOB -->
                <mat-form-field appearance="outline" class="form-field">
                    <mat-label>Date of Birth</mat-label>
                    <input matInput [matDatepicker]="picker" formControlName="dob" [matDatepickerFilter]="myDateFilter"
                        (keydown)="onKeyDown($event)">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                    <mat-error *ngIf="form.get('dob')?.invalid && form.get('dob')?.touched">
                        Field is required
                    </mat-error>
                </mat-form-field>


                <div fxlayout="row" fxLayoutGap="10px">
                    <div fxFlex="50">
                        <!-- Address -->
                        <mat-form-field appearance="outline" class="form-field" #address1Input
                            (mouseenter)="errorMessage6.style.display = (form.get('address1')?.invalid && form.get('address1')?.touched) ? 'block' : 'none'"
                            (mouseleave)="errorMessage6.style.display = 'none'">
                            <mat-label>Address 1</mat-label>
                            <input matInput formControlName="address1" required>
                            <span matSuffix *ngIf="form.get('address1')?.invalid && form.get('address1')?.touched">
                                <mat-icon class="alert">priority_high</mat-icon>
                            </span>
                            <div class="custom-message" #errorMessage6
                                [style.display]="(form.get('address1')?.invalid && form.get('address1')?.touched) ? 'block' : 'none'">
                                Field is required
                            </div>
                        </mat-form-field>
                        <!-- City -->
                        <mat-form-field appearance="outline" class="form-field" #cityInput
                            (mouseenter)="errorMessage8.style.display = (form.get('city')?.invalid && form.get('city')?.touched) ? 'block' : 'none'"
                            (mouseleave)="errorMessage8.style.display = 'none'">
                            <mat-label>City</mat-label>
                            <input matInput formControlName="city">
                            <span matSuffix *ngIf="form.get('city')?.invalid && form.get('city')?.touched">
                                <mat-icon class="alert">priority_high</mat-icon>
                            </span>
                            <div class="custom-message" #errorMessage8
                                [style.display]="(form.get('city')?.invalid && form.get('city')?.touched) ? 'block' : 'none'">
                                Field is required
                            </div>
                        </mat-form-field>
                        <!-- Postal Code -->
                        <mat-form-field appearance="outline" class="form-field" #postalCodeInput
                            (mouseenter)="errorMessage10.style.display = (form.get('postalCode')?.invalid && form.get('postalCode')?.touched) ? 'block' : 'none'"
                            (mouseleave)="errorMessage10.style.display = 'none'">
                            <mat-label>Postal Code</mat-label>
                            <input matInput formControlName="postalCode" required (keydown)="onKeyDown($event)"
                                maxlength="7">
                            <span matSuffix *ngIf="form.get('postalCode')?.invalid && form.get('postalCode')?.touched">
                                <mat-icon class="alert">priority_high</mat-icon>
                            </span>
                            <div class="custom-message" #errorMessage10
                                [style.display]="(form.get('postalCode')?.invalid && form.get('postalCode')?.touched) ? 'block' : 'none'">
                                <ng-container *ngIf="form.get('postalCode')?.hasError('required')">
                                    Field is required
                                </ng-container>
                                <ng-container *ngIf="form.get('postalCode')?.hasError('pattern')">
                                    Invalid postal code format. Please enter a valid 6-digit PIN code.
                                </ng-container>
                            </div>
                        </mat-form-field>
                    </div>
                    <div fxFlex="50">
                        <!-- Address 2 -->
                        <mat-form-field appearance="outline" class="form-field" #address2Input
                            (mouseenter)="errorMessage7.style.display = (form.get('address2')?.invalid && form.get('address2')?.touched) ? 'block' : 'none'"
                            (mouseleave)="errorMessage7.style.display = 'none'">
                            <mat-label>Address 2</mat-label>
                            <input matInput formControlName="address2">
                            <span matSuffix *ngIf="form.get('address2')?.invalid && form.get('address2')?.touched">
                                <mat-icon class="alert">priority_high</mat-icon>
                            </span>
                            <div class="custom-message" #errorMessage7
                                [style.display]="(form.get('address2')?.invalid && form.get('address2')?.touched) ? 'block' : 'none'">
                                Field is required
                            </div>
                        </mat-form-field>
                        <!-- Country -->
                        <mat-form-field appearance="outline" class="form-field" #countryInput
                            (mouseenter)="errorMessage9.style.display = (form.get('country')?.invalid && form.get('country')?.touched) ? 'block' : 'none'"
                            (mouseleave)="errorMessage9.style.display = 'none'">
                            <mat-label>Country</mat-label>
                            <input matInput formControlName="country" required>
                            <span matSuffix *ngIf="form.get('country')?.invalid && form.get('country')?.touched">
                                <mat-icon class="alert">priority_high</mat-icon>
                            </span>
                            <div class="custom-message" #errorMessage9
                                [style.display]="(form.get('country')?.invalid && form.get('country')?.touched) ? 'block' : 'none'">
                                Field is required
                            </div>
                        </mat-form-field>
                        <!-- Mobile Number -->
                        <mat-form-field appearance="outline" class="form-field" #phoneNoInput
                            (mouseenter)="errorMessage11.style.display = (form.get('phoneNo')?.invalid && form.get('phoneNo')?.touched) ? 'block' : 'none'"
                            (mouseleave)="errorMessage11.style.display = 'none'">
                            <mat-label>Phone Number</mat-label>
                            <input matInput formControlName="phoneNo">
                            <span matSuffix *ngIf="form.get('phoneNo')?.invalid && form.get('phoneNo')?.touched">
                                <mat-icon class="alert">priority_high</mat-icon>
                            </span>
                            <div class="custom-message" #errorMessage11
                                [style.display]="(form.get('phoneNo')?.invalid && form.get('phoneNo')?.touched) ? 'block' : 'none'">
                                Field is required
                            </div>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>

<!-- Bottom section of the dialog -->
<div class="bottom-padding top-shadow">
    <div fxlayout="row" fxLayoutAlign="end">
        <button mat-raised-button class="cancel" type="button" mat-dialog-close>Cancel</button>
        <button mat-raised-button color="warn" type="submit" (click)="onSubmit()">
            <span *ngIf="!loading">Save &
                close</span>
            <span *ngIf="loading" [ngClass]="{ spinner: loading, 'add-button': loading }">
            </span>
        </button>
    </div>
</div>